import { render, staticRenderFns } from "./SC_Popup.vue?vue&type=template&id=0b9adbd1"
import script from "./SC_Popup.vue?vue&type=script&lang=js"
export * from "./SC_Popup.vue?vue&type=script&lang=js"
import style0 from "./SC_Popup.vue?vue&type=style&index=0&id=0b9adbd1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports